"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsJsonEncryption = void 0;
const utilsSecret_1 = require("../utilsSecret");
class UtilsJsonEncryption {
    constructor() {
        this.fileSecret = new utilsSecret_1.UtilsSecret();
        this.SALT = 'jeep_capacitor_sqlite';
        this.Crypto = require('crypto');
        this.CryptoJS = require('crypto-js');
    }
    /**
     * deriveKeyFromPassphrase
     * Function to derive a symmetric key from passphrase and salt using PBKDF2
     * @param passphrase
     * @param salt
     * @returns
     */
    deriveKeyFromPassphrase(passphrase, salt) {
        const iterations = 10000; // Recommended number of iterations for PBKDF2
        const keyLength = 32;
        const key = this.Crypto.pbkdf2Sync(passphrase, salt, iterations, keyLength, 'sha256');
        const keyHex = Buffer.from(key).toString('hex');
        return keyHex;
    }
    /**
     * encryptJSONObject
     * Function to encrypt JSON object with AES and return as Base64
     * @param jsonObj
     * @returns
     */
    encryptJSONObject(jsonObj) {
        const jsonString = JSON.stringify(jsonObj);
        // get the passphrase
        const passphrase = this.fileSecret.getPassphrase();
        // derived a combined key from passphrase and salt
        const key = this.deriveKeyFromPassphrase(passphrase, this.SALT);
        const encrypted = this.CryptoJS.AES.encrypt(jsonString, key).toString();
        const encryptedBase64 = Buffer.from(encrypted).toString('base64');
        return encryptedBase64;
    }
    /**
     * decryptJSONObject
     * Function to decrypt AES encrypted JSON object from Base64
     * @param encryptedBase64
     * @returns
     */
    decryptJSONObject(encryptedBase64) {
        const encryptedData = Buffer.from(encryptedBase64, 'base64').toString();
        // get the passphrase
        const passphrase = this.fileSecret.getPassphrase();
        // derived a combined key from passphrase and salt
        const key = this.deriveKeyFromPassphrase(passphrase, this.SALT);
        const bytes = this.CryptoJS.AES.decrypt(encryptedData, key);
        const decryptedString = bytes.toString(this.CryptoJS.enc.Utf8);
        const decryptedObj = JSON.parse(decryptedString);
        return decryptedObj;
    }
}
exports.UtilsJsonEncryption = UtilsJsonEncryption;
//# sourceMappingURL=utilsJsonEncryption.js.map